// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FeedbackModal - Centered modal over HelpDrawer */

.feedback-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.feedback-modal-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 16px;
  padding: 32px 36px;
  max-width: 540px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  position: relative;
}

.feedback-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #666;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  transition: color 0.2s ease;
}

.feedback-modal-close:hover {
  color: #aeb9cc;
}

.feedback-modal-title {
  color: #fdfdfd;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.feedback-modal-subtitle {
  color: #aeb9cc;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 16px 0;
}

.feedback-modal-guidance {
  background: rgba(33, 138, 255, 0.08);
  border: 1px solid rgba(33, 138, 255, 0.25);
  border-radius: 8px;
  padding: 12px 16px;
  color: #aeb9cc;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.feedback-modal-field {
  margin-bottom: 16px;
}

.feedback-modal-label {
  display: block;
  color: #b0b0b0;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.feedback-modal-input {
  width: 100%;
  padding: 10px 12px;
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.feedback-modal-input:focus {
  outline: none;
  border-color: #218aff;
  box-shadow: 0 0 0 2px rgba(33, 138, 255, 0.15);
}

.feedback-modal-input:disabled {
  color: #888;
  cursor: not-allowed;
}

.feedback-modal-textarea {
  width: 100%;
  padding: 10px 12px;
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.feedback-modal-textarea:focus {
  outline: none;
  border-color: #218aff;
  box-shadow: 0 0 0 2px rgba(33, 138, 255, 0.15);
}

/* Image preview thumbnails */
.feedback-modal-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.feedback-modal-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #444;
}

.feedback-modal-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feedback-modal-preview-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: #fff;
  font-size: 11px;
  cursor: pointer;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.feedback-modal-preview-remove:hover {
  background: #ef4444;
}

/* Attach images bar */
.feedback-modal-image-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.feedback-modal-attach-btn {
  padding: 6px 14px;
  background: transparent;
  color: #b0b0b0;
  font-size: 13px;
  border: 1px solid #444;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.feedback-modal-attach-btn:hover {
  background: #333;
  color: #fff;
  border-color: #555;
}

.feedback-modal-attach-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.feedback-modal-paste-hint {
  color: #666;
  font-size: 12px;
}

.feedback-modal-image-count {
  color: #888;
  font-size: 12px;
  margin-left: auto;
}

/* Error */
.feedback-modal-error {
  color: #ef4444;
  font-size: 13px;
  margin: 0 0 12px 0;
}

/* Action buttons */
.feedback-modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.feedback-modal-btn-primary {
  padding: 10px 24px;
  background: #218aff;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.feedback-modal-btn-primary:hover {
  background: #1a7aef;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
}

.feedback-modal-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.feedback-modal-btn-secondary {
  padding: 10px 20px;
  background: transparent;
  color: #aeb9cc;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #444;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.feedback-modal-btn-secondary:hover {
  background: #333;
  color: #fdfdfd;
  border-color: #555;
}

.feedback-modal-btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Success state */
.feedback-modal-success {
  text-align: center;
  padding: 24px 0;
}

.feedback-modal-success-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  background: #10b981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.feedback-modal-success-title {
  color: #fdfdfd;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.feedback-modal-success-text {
  color: #aeb9cc;
  font-size: 14px;
  margin: 0;
}

/* Responsive */
@media (max-width: 600px) {
  .feedback-modal-card {
    padding: 24px 20px;
    max-width: 100%;
  }

  .feedback-modal-title {
    font-size: 18px;
  }

  .feedback-modal-buttons {
    flex-direction: column;
  }

  .feedback-modal-btn-primary,
  .feedback-modal-btn-secondary {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Help/FeedbackModal.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* FeedbackModal - Centered modal over HelpDrawer */\n\n.feedback-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.feedback-modal-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 16px;\n  padding: 32px 36px;\n  max-width: 540px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  position: relative;\n}\n\n.feedback-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.feedback-modal-close:hover {\n  color: #aeb9cc;\n}\n\n.feedback-modal-title {\n  color: #fdfdfd;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n}\n\n.feedback-modal-subtitle {\n  color: #aeb9cc;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0 0 16px 0;\n}\n\n.feedback-modal-guidance {\n  background: rgba(33, 138, 255, 0.08);\n  border: 1px solid rgba(33, 138, 255, 0.25);\n  border-radius: 8px;\n  padding: 12px 16px;\n  color: #aeb9cc;\n  font-size: 13px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.feedback-modal-field {\n  margin-bottom: 16px;\n}\n\n.feedback-modal-label {\n  display: block;\n  color: #b0b0b0;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.feedback-modal-input {\n  width: 100%;\n  padding: 10px 12px;\n  background: #1a1a1a;\n  border: 1px solid #444;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.feedback-modal-input:focus {\n  outline: none;\n  border-color: #218aff;\n  box-shadow: 0 0 0 2px rgba(33, 138, 255, 0.15);\n}\n\n.feedback-modal-input:disabled {\n  color: #888;\n  cursor: not-allowed;\n}\n\n.feedback-modal-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  background: #1a1a1a;\n  border: 1px solid #444;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  resize: vertical;\n  min-height: 100px;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.feedback-modal-textarea:focus {\n  outline: none;\n  border-color: #218aff;\n  box-shadow: 0 0 0 2px rgba(33, 138, 255, 0.15);\n}\n\n/* Image preview thumbnails */\n.feedback-modal-previews {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.feedback-modal-preview-item {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #444;\n}\n\n.feedback-modal-preview-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.feedback-modal-preview-remove {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  color: #fff;\n  font-size: 11px;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.feedback-modal-preview-remove:hover {\n  background: #ef4444;\n}\n\n/* Attach images bar */\n.feedback-modal-image-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.feedback-modal-attach-btn {\n  padding: 6px 14px;\n  background: transparent;\n  color: #b0b0b0;\n  font-size: 13px;\n  border: 1px solid #444;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.feedback-modal-attach-btn:hover {\n  background: #333;\n  color: #fff;\n  border-color: #555;\n}\n\n.feedback-modal-attach-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.feedback-modal-paste-hint {\n  color: #666;\n  font-size: 12px;\n}\n\n.feedback-modal-image-count {\n  color: #888;\n  font-size: 12px;\n  margin-left: auto;\n}\n\n/* Error */\n.feedback-modal-error {\n  color: #ef4444;\n  font-size: 13px;\n  margin: 0 0 12px 0;\n}\n\n/* Action buttons */\n.feedback-modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.feedback-modal-btn-primary {\n  padding: 10px 24px;\n  background: #218aff;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.feedback-modal-btn-primary:hover {\n  background: #1a7aef;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n}\n\n.feedback-modal-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.feedback-modal-btn-secondary {\n  padding: 10px 20px;\n  background: transparent;\n  color: #aeb9cc;\n  font-size: 14px;\n  font-weight: 500;\n  border: 1px solid #444;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.feedback-modal-btn-secondary:hover {\n  background: #333;\n  color: #fdfdfd;\n  border-color: #555;\n}\n\n.feedback-modal-btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Success state */\n.feedback-modal-success {\n  text-align: center;\n  padding: 24px 0;\n}\n\n.feedback-modal-success-icon {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 16px;\n  background: #10b981;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.feedback-modal-success-title {\n  color: #fdfdfd;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n}\n\n.feedback-modal-success-text {\n  color: #aeb9cc;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .feedback-modal-card {\n    padding: 24px 20px;\n    max-width: 100%;\n  }\n\n  .feedback-modal-title {\n    font-size: 18px;\n  }\n\n  .feedback-modal-buttons {\n    flex-direction: column;\n  }\n\n  .feedback-modal-btn-primary,\n  .feedback-modal-btn-secondary {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
